export const DDIA_PROPOSAL_INFO_FORM_ID = 'ddia-proposal-info-form';
